import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Users, Mail, ArrowRight, ClipboardList } from "lucide-react";
import { getModuleRoute, visibleModuleMenus } from "../utils/moduleRoutes";
import "../styles/components/ModuleLinks.css";

const readMenus = () => {
  try { return visibleModuleMenus(JSON.parse(localStorage.getItem("sidebarItems") || "[]")); }
  catch (_) { return []; }
};

export default function ModuleLinks() {
  const [menus, setMenus] = useState(readMenus);
  useEffect(() => {
    const reload = () => setMenus(readMenus());
    window.addEventListener("sidebarItemsUpdated", reload);
    window.addEventListener("storage", reload);
    return () => { window.removeEventListener("sidebarItemsUpdated", reload); window.removeEventListener("storage", reload); };
  }, []);
  if (!menus.length) return null;
  return <nav className="erp-module-links" aria-label="Your modules">{menus.map((menu, index) => {
    const path = getModuleRoute(menu);
    const Icon = path === "/purchase/comparisons" ? ClipboardList : path.startsWith("/modules/hr") ? Users : Mail;
    return <Link key={`${menu.menu_item_id || menu.menu_code}-${index}`} to={path}><Icon size={22} aria-hidden="true" /><span>{menu.display_title || menu.title || menu.menu_code}</span><ArrowRight size={17} aria-hidden="true" /></Link>;
  })}</nav>;
}